"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timestampsProperties = void 0;
const propertyCreatedAt = {
    title: "作成日時",
    propertyName: "createdAt",
    schema: { schemaType: "datetime" },
};
const propertyUpdatedAt = {
    title: "更新日時",
    propertyName: "updatedAt",
    schema: { schemaType: "datetime" },
};
exports.timestampsProperties = [
    propertyCreatedAt,
    propertyUpdatedAt,
];
